'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dImage$002dSearch from "./mealorama.-Image-Search.js";
var $p;
/** @constructor */
function $c_Lmealorama_ImageSearch$() {
}
export { $c_Lmealorama_ImageSearch$ as $c_Lmealorama_ImageSearch$ };
$p = $c_Lmealorama_ImageSearch$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ImageSearch$;
/** @constructor */
function $h_Lmealorama_ImageSearch$() {
}
export { $h_Lmealorama_ImageSearch$ as $h_Lmealorama_ImageSearch$ };
$h_Lmealorama_ImageSearch$.prototype = $p;
$p.m = (function() {
  return "ImageSearch";
});
$p.aSi = (function(x$0) {
  return new $j_mealorama$002e$002dImage$002dSearch.$c_Lmealorama_ImageSearch(x$0.g(0), (x$0.g(1) | 0), (x$0.g(2) | 0), x$0.g(3));
});
var $d_Lmealorama_ImageSearch$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ImageSearch$, "mealorama.ImageSearch$", ({
  FR: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_ImageSearch$ as $d_Lmealorama_ImageSearch$ };
var $n_Lmealorama_ImageSearch$;
function $m_Lmealorama_ImageSearch$() {
  if ((!$n_Lmealorama_ImageSearch$)) {
    $n_Lmealorama_ImageSearch$ = new $c_Lmealorama_ImageSearch$();
  }
  return $n_Lmealorama_ImageSearch$;
}
export { $m_Lmealorama_ImageSearch$ as $m_Lmealorama_ImageSearch$ };
//# sourceMappingURL=mealorama.-Image-Search$.js.map
